import { Component, OnInit } from "@angular/core";

import { DimmerService } from "app/core/services/dimmer.service";
import { SystemService } from "app/core/services/system.service";
import { ApplicationInfo } from "app/core/models/application-info";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"]
})
export class AboutComponent implements OnInit {

  shouldShowDisclaimer: boolean = false;
  appInfo: ApplicationInfo;

  constructor(
    private dimmerService: DimmerService,
    private systemService: SystemService
  ) {}

  ngOnInit() {

    //get app info

    this.systemService.appInfo.subscribe(appInfo => {
      this.appInfo = appInfo;
    });

  }

  openDisclaimer() {

    this.dimmerService.dimWindow(true);
    this.shouldShowDisclaimer = true;

  }

  closeDisclaimer(){

    this.dimmerService.dimWindow(false);
    this.shouldShowDisclaimer = false;
  }

  openFeedback() {}
}
